export default {
    ui: {
        helpAria: "Apri il tutorial per questa sezione",
        slideOf: "Slide {{current}} di {{total}}",
        getStarted: "Inizia",
        dialogIntro: "Introduzione a quest'area",
        goToSlide: "Vai alla slide {{n}} di {{total}}",
    },
    shipper: {
        askEve: {
            label: "Ask Eve",
            mockUi: {
                eveName: "Eve",
                assistantSubtitle: "Assistente AI",
                typingStatus: "Sta scrivendo",
                yourMessage: "Tu",
                eveReply: "Eve",
                composeTitle: "Scrivi il messaggio",
                placeholder: "Fai una domanda…",
                send: "Invia",
            },
            slides: [
                {
                    title: "Benvenuto in Ask Eve",
                    body: "Il tuo assistente AI per spedizioni, documenti e prossimi passi. Fai domande in linguaggio naturale e ricevi risposte collegate al tuo workspace.",
                    mock: "eve-chat-intro",
                },
                {
                    title: "Aiuto contestuale",
                    body: "Eve può suggerire azioni, riassumere lo stato e segnalare rischi usando gli stessi dati che vedi altrove in EveMind, senza saltare tra le pagine.",
                    mock: "eve-context-cards",
                },
                {
                    title: "Continua la conversazione",
                    body: "Resta nello stesso filo per affinare una richiesta, aggiungere dettagli o esplorare un altro punto di vista sullo stesso tema.",
                    mock: "eve-thread",
                },
                {
                    title: "Sei tu a decidere",
                    body: "Quando sei pronto, chiudi questo tour e scrivi la prima domanda nella chat. Puoi riaprire questa guida in qualsiasi momento con il pulsante di aiuto.",
                    mock: "eve-compose",
                },
            ],
        },
        controlHub: {
            label: "Control Hub",
            slides: [
                {
                    title: "Il tuo Control Hub",
                    body: "Un unico punto per capire come sta andando l'operazione e su cosa concentrarti oggi, prima di entrare nei singoli moduli.",
                    mock: "hub-hero-cards",
                },
                {
                    title: "Priorità a colpo d'occhio",
                    body: "Metriche e segnali chiave ti aiutano a individuare ritardi, rischio e carico di lavoro senza aprire ogni area dell'applicazione.",
                    mock: "hub-kpis",
                },
                {
                    title: "Dall'insight all'azione",
                    body: "Usa l'hub per passare a operazioni, coordinamento o flussi commerciali con il contesto necessario per decidere in fretta.",
                    mock: "hub-shortcuts",
                },
                {
                    title: "Pronto a esplorare",
                    body: "Chiudi questa introduzione e scorri l'hub. Questo tour non comparirà più a meno che tu non lo apra dal pulsante di aiuto.",
                    mock: "hub-ready",
                },
            ],
        },
        operations: {
            label: "Operazioni",
            slides: [
                {
                    title: "Area Operazioni",
                    body: "Gestisci container, segui il live tracking e tieni i documenti in ordine: l'area operativa quotidiana per chi spedisce merci.",
                    mock: "ops-modules",
                },
                {
                    title: "Container e tracking",
                    body: "Monitora tappe, rotte e aggiornamenti di stato per sapere cosa si muove, cosa è in ritardo e cosa richiede attenzione.",
                    mock: "ops-route",
                },
                {
                    title: "Documenti in un solo posto",
                    body: "Carica, classifica e trova i documenti di spedizione collegati alle tue movimentazioni, per validazioni e passaggi di consegna più rapidi.",
                    mock: "ops-files",
                },
                {
                    title: "Entra nel dettaglio",
                    body: "Scegli Container, Live tracking o Documenti dalla barra laterale. Puoi rivedere questo tour quando vuoi dal pulsante di aiuto.",
                    mock: "ops-nav-hint",
                },
            ],
        },
        coordination: {
            label: "Coordinamento",
            slides: [
                {
                    title: "Resta allineato",
                    body: "Activity, Issues e Review center lavorano insieme: il team vede cosa è cambiato, cosa non va e cosa richiede ancora una decisione umana.",
                    mock: "coord-pillars",
                },
                {
                    title: "Feed Activity",
                    body: "Segui un flusso cronologico di notifiche e aggiornamenti sulle tue spedizioni, così nulla di importante resta sepolto in email.",
                    mock: "coord-feed",
                },
                {
                    title: "Issues e review",
                    body: "Tieni sotto controllo problemi aperti e revisioni in sospeso: risolvi blocchi e approvazioni prima che diventino ritardi o costi extra.",
                    mock: "coord-tickets",
                },
                {
                    title: "Tieni tutto sotto controllo",
                    body: "Consulta spesso queste aree per sbloccare in anticipo. Chiudi il tour quando vuoi iniziare dalla barra laterale.",
                    mock: "coord-rhythm",
                },
            ],
        },
        commercial: {
            label: "Commerciale",
            slides: [
                {
                    title: "Flussi commerciali",
                    body: "Gestisci ordini e preventivi nautici in un'unica macro-area allineata a come compri, vendi e movimenti il carico.",
                    mock: "comm-bridge",
                },
                {
                    title: "Ordini",
                    body: "Crea e monitora ordini collegati alla tua pipeline logistica, così l'intento commerciale resta legato all'esecuzione.",
                    mock: "comm-order-card",
                },
                {
                    title: "Preventivi",
                    body: "Richiedi e confronta preventivi di trasporto per bilanciare prezzo, livello di servizio e tempistiche su ogni spedizione.",
                    mock: "comm-quote-compare",
                },
                {
                    title: "Chiudi il cerchio",
                    body: "Passa dalle decisioni commerciali alle operazioni senza perdere contesto. Chiudi il tour per continuare in Ordini o Preventivi.",
                    mock: "comm-handoff",
                },
            ],
        },
        network: {
            label: "Rete",
            slides: [
                {
                    title: "La tua rete",
                    body: "Partner, team e contatti sono la base di uno shipping affidabile: qui li tieni organizzati.",
                    mock: "net-graph",
                },
                {
                    title: "Partner commerciali",
                    body: "Cura i rapporti con spedizionieri, vettori e controparti con cui lavori, così ogni spedizione rimanda alla parte giusta.",
                    mock: "net-partner-cards",
                },
                {
                    title: "Team e accessi",
                    body: "Invita i colleghi e gestisci chi può vedere o agire sui dati aziendali: fondamentale per collaborare in sicurezza.",
                    mock: "net-team-row",
                },
                {
                    title: "Rubrica indirizzi",
                    body: "Centralizza contatti e sedi così moduli e documenti restano coerenti. Chiudi il tour quando sei pronto a esplorare.",
                    mock: "net-contact-card",
                },
            ],
        },
    },
};
